import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { store } from './modules/redux/store/store';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// import 'fast-text-encoding/text';
import { App } from './App';

ReactDOM.render(
  <Router basename='/fevci-ppu'>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// import {
//   React,
//   ReactDOM,
//   Provider,
//   BrowserRouter as Router
// } from './libraries/libraries'
// import * as serviceWorker from './serviceWorker'
// import { store } from './modules/redux/store/store'
// import 'react-app-polyfill/ie11'
// import 'react-app-polyfill/stable'
// // import 'fast-text-encoding/text'
// import { App } from './App';

// ReactDOM.render(
//   <Router>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </Router>,
//   document.getElementById('root')
// )

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()
